import React, { useState } from 'react'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import { PenSquare, Clock } from 'lucide-react'
import ModernPostScheduling from 'components/PostScheduling/PostScheduling'
import UserPosts from 'pages/UserPosts/UserPosts'

export default function Posts() {
  const [tab, setTab] = useState(0)

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: 'auto' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 3 }}>
        Posts
      </Typography>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{
          mb: 3,
          '& .MuiTabs-indicator': {
            background: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
            height: 3,
            borderRadius: 2,
          },
          '& .MuiTab-root': {
            color: 'rgba(255,255,255,0.5)',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '15px',
            '&.Mui-selected': { color: 'white' },
          },
        }}
      >
        <Tab icon={<PenSquare size={18} />} iconPosition="start" label="Schedule" />
        <Tab icon={<Clock size={18} />} iconPosition="start" label="Manage Posts" />
      </Tabs>

      {tab === 0 && <ModernPostScheduling />}
      {tab === 1 && <UserPosts />}
    </Box>
  )
}
